module.exports = __webpack_public_path__ + "ida-5f2d711aff9ca7d0d665f704e5a785b3.png";